<template>
  <RouterView />
</template>

<script setup>
  import { userStore } from '@/stores/user';
  import { intervalFunStore } from '@/stores/intervalFunStore';
  import { watch, computed, onMounted } from 'vue';
  import ws from '@/utils/websocket.js';
  import { storeToRefs } from 'pinia';
  const { currentUser } = storeToRefs(userStore());
  const { websocketInfo } = storeToRefs(intervalFunStore());
  const { setIntervalFun, websocketClose } = intervalFunStore();

  const cardNum = computed(() => (currentUser.value ? currentUser.value.cardNum : null));

  watch(
    () => cardNum.value,
    newVal => {
      if (newVal) {
        console.log('setIntervalFun', 'setIntervalFun');
        setIntervalFun();
      } else {
        if (websocketInfo.value) {
          websocketClose();
        }
      }
    },
    { deep: true, immediate: true }
  );
</script>
<style scoped></style>
